<template>
  <div id="mainPage">
    <header>
      <Header />
      <BreadcrumbList />
    </header>
    <div id="main" :class="{ background10sen: is10sen }">
      <div class="swiper-container">
        <div class="swiper-wrapper">
          <div class="swiper-slide"
            v-for="winner in virtualData.slides"
            :key="winner.id"
            :style="slideStyles"
          >
            <section class="artwork">
              <div class="inner2" v-if="winner.awardType !== 99">
                <h1 class="photographer" >{{awardTypeNames[winner.awardType]}}<br>
                  <span class="titleSub" v-if="winner.awardType === 9" >100 Cultural & Landscape Photos of Japan</span>
                  <span class="titleSub" v-else-if="winner.awardType === 10" >「大切な存在」フォトコンテスト</span>
                  <span class="titleSub" v-else >The 10 Photographers of {{get10SenYear(winner.id)}}</span>
                  <br><strong>{{winner.name}}</strong><br>
                </h1>
                <p class="nameSub">
                  <span v-if="winner.nameOption1">{{winner.nameOption1}}</span><br>
                  <span v-if="winner.nameOption2">{{winner.nameOption2}}</span>
                </p>
              </div><!-- /inner2-->

              <div v-if="winner && winner.winnerIntroduction && (winner.winnerIntroduction.comment || winner.winnerIntroduction.youtubeUrl || winner.winnerIntroduction.voice)" class="exhCommentary">
                <a href="javascript:void(0);" @click="changeCommentaryMode(false)" class="exhCommentaryLink"><div class="exhCommentaryNavi">
                  <p>展示解説</p>
                  <img v-if="isCommentExists(winner)" class="expTxtBtn" src="/img/expTxt.png" srcset="/img/expTxt@2x.png 2x" alt="テキスト解説" />
                  <img v-if="isMovieExists(winner)" class="expMovieBtn" src="/img/expMovie.png" srcset="/img/expMovie@2x.png 2x" alt="動画解説" />
                  <img v-if="isVoiceExists(winner)" class="expVoiceBtn" src="/img/expVoice.png" srcset="/img/expVoice@2x.png 2x" alt="音声解説" />
                </div></a>
                <div style="overflow: auto;">
                <div class="exhCommentaryBody openCloseAnimation" :class="{ hideCommentary: isWinnerIntroductionClose[winner.id] }" :style="{ marginTop: (- winner.minusMargin) + 'px' }" :id="'openClose-' + winner.id">
                  <div class="inner2">
                    <div v-if="isCommentExists(winner)" class="expTxt">
                      <p>{{winner.winnerIntroduction.comment}}</p>
                    </div>
                    <div v-if="isVoiceExists(winner)" class="expMovie">
                      <audio
                          v-if="winner && winner.winnerIntroduction && winner.winnerIntroduction.voiceUrl"
                          class="my-1"
                          controls
                          :src="winner.winnerIntroduction.voiceUrl">
                              音声再生がサポートされていないブラウザです。
                      </audio>
                    </div>
                    <div v-if="isMovieExists(winner)" class="expMovie">
                      <iframe width="320" height="180" :src="convertYoutubeUrl(winner.winnerIntroduction.youtubeUrl)" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                    </div>

                  </div><!-- /inner-->
                  <a href="javascript:void(0);" @click="changeCommentaryMode(true)"><div class="exhCommentaryClose"><img src="/img/expClose.png" srcset="/img/expClose@2x.png 2x" class="notSwipe" alt=""/></div></a>
                </div><!-- /exhCommentaryBody-->
                </div>
              </div><!-- /exhCommentary-->

              <PhotoWall201901 v-if="winner.id === 201901" :winner="winner" :openImageViewer="openImageViewer" />
              <PhotoWall201902 v-else-if="winner.id === 201902" :winner="winner" :openImageViewer="openImageViewer" />
              <PhotoWall201903 v-else-if="winner.id === 201903" :winner="winner" :openImageViewer="openImageViewer" />
              <PhotoWall201904 v-else-if="winner.id === 201904" :winner="winner" :openImageViewer="openImageViewer" />
              <PhotoWall201905 v-else-if="winner.id === 201905" :winner="winner" :openImageViewer="openImageViewer" />
              <PhotoWall201906 v-else-if="winner.id === 201906" :winner="winner" :openImageViewer="openImageViewer" />
              <PhotoWall201907 v-else-if="winner.id === 201907" :winner="winner" :openImageViewer="openImageViewer" />
              <PhotoWall201908 v-else-if="winner.id === 201908" :winner="winner" :openImageViewer="openImageViewer" />
              <PhotoWall201909 v-else-if="winner.id === 201909" :winner="winner" :openImageViewer="openImageViewer" />
              <PhotoWall201910 v-else-if="winner.id === 201910" :winner="winner" :openImageViewer="openImageViewer" />
              <PhotoWall10Sen v-else-if="winner.awardType >= 2 && winner.awardType <= 8" :winner="winner" :openImageViewer="openImageViewer" />
              <PhotoWall100Kei v-else-if="winner.awardType == 9" :winner="winner" :openImageViewer="openImageViewer" />
              <PhotoWallMyPrecious v-else-if="winner.awardType == 10" :winner="winner" :openImageViewer="openImageViewer" />
              <PhotoWallSpacer v-else :winner="winner" />
            </section>

            <section v-if="isProfileExists(winner)" class="profile">
              <div class="inner2 clearfix">
                <div v-if="winner.profileImageUrl" class="left"><img class="profImg" :src="winner.profileImageUrl" alt=""/></div>
                <div v-if="winner.profileStatement" class="right">
                    <h3 class="profName" style="word-break: break-all;;">{{winner.name}}</h3><h4 v-if="winner.nameOption1" class="profNameSub">{{winner.nameOption1}}</h4>
                    <p v-if="winner.profileStatement" class="profTxt">
                      <span v-html="sanitizeAndAutoLink(winner.profileStatement)" style="white-space: pre-wrap;" />
                    </p>
                    <a v-if="winner.portfolios && winner.portfolios[0] && winner.portfolios[0].portfolioWorks" href="javascript:void(0);" class="portfolio StandardBtn notSwipe" @click.stop="openPortfolioViewer(winner)">
                      ポートフォリオを見る
                    </a>
                </div>
                <!-- プロフィールは無いが、ポートフォリオだけある場合 -->
                <div v-else-if="!winner.profileStatement && winner.portfolios && winner.portfolios[0] && winner.portfolios[0].portfolioWorks" class="right">
                    <h3 class="profName" style="word-break: break-all;">{{winner.name}}</h3><h4 v-if="winner.nameOption1" class="profNameSub">{{winner.nameOption1}}</h4><br>
                    <a v-if="winner.portfolios && winner.portfolios[0] && winner.portfolios[0].portfolioWorks" href="javascript:void(0);" class="portfolio StandardBtn notSwipe" @click.stop="openPortfolioViewer(winner)">
                      ポートフォリオを見る
                    </a>
                </div>
              </div><!-- /inner-->
            </section><!-- /profile-->

            <section v-if="winner && winner.isComment" class="message">
              <div class="inner2">
                <Comment :categoryId="winner.id" :commentType="EnumCommentTypeWinner" :ref="'comment' + winner.id" />
              </div>
            </section>

            <section v-if="winner.awardType == 9 && !isDemo()" class="photospotArea">
                <div class="inner2">
                  <div class="photospotBanner">
                    <a :href="linkUrl100Kei + winner.winningWorks[0].sheetaWorkId + '&utm_source=tokyocameraclub&utm_medium=banner&utm_campaign=exh2020'" target="_blank">
                      <img src="/img/photospot_banner.png">
                    </a>
                  </div>
                </div><!-- /inner-->
            </section><!-- /photospotArea-->

          </div>
        </div>
      </div>
    </div>
    <div class="cursorRight" :class="{ cursorDisable: this.currentIndex == (this.winners.length - 1) }">
      <a href="javascript:void(0);" @click="moveNext" :class="{ cursorDisable: this.currentIndex == (this.winners.length - 1) }">
        <img src="/img/arwRight.png" srcset="/img/arwRight@2x.png" style="filter: blur(0px)" />
      </a>
    </div>
    <div class="cursorLeft" :class="{ cursorDisable: this.currentIndex == 0 }">
      <a href="javascript:void(0);" @click="movePrev" :class="{ cursorDisable: this.currentIndex == 0 }">
        <img src="/img/arwLeft.png" srcset="/img/arwLeft@2x.png" style="filter: blur(0px)" />
      </a>
    </div>
    <MessageDialog :isOpen.sync="isMessageOpen" :title="messageTitle" :text="messageText" />
    <Footer />
    <ImageViewer
      :isOpen.sync="isImageViewerOpen"
      :winner="currentWinner"
      :winningWork="currentWinningWork"
      :commentaryType="commentaryType"
    />
    <PortfolioViewer
      :isOpen.sync="isPortfolioViewerOpen"
      :winner="currentWinner"
    />
    <UpButton />
    <QuestionnaireButton />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Header from '@/components/modules/Header.vue'
import BreadcrumbList from '@/components/modules/BreadcrumbList.vue'
import Footer from '@/components/modules/Footer.vue'
import ImageViewer from '@/components/modules/ImageViewer.vue'
import PortfolioViewer from '@/components/modules/PortfolioViewer.vue'
import enumMixin from '@/concern/enumMixin'
import constMixin from '@/concern/constMixin'
import Swiper from 'swiper/bundle'
import Comment from '@/components/modules/Comment.vue'
import MessageDialog from '@/components/modules/MessageDialog.vue'
import sanitizeHtml from 'sanitize-html'
import AutoLinkUtil from '@/util/AutoLinkUtil'
import PhotoWall201901 from '@/components/modules/photoWall/PhotoWall201901.vue'
import PhotoWall201902 from '@/components/modules/photoWall/PhotoWall201902.vue'
import PhotoWall201903 from '@/components/modules/photoWall/PhotoWall201903.vue'
import PhotoWall201904 from '@/components/modules/photoWall/PhotoWall201904.vue'
import PhotoWall201905 from '@/components/modules/photoWall/PhotoWall201905.vue'
import PhotoWall201906 from '@/components/modules/photoWall/PhotoWall201906.vue'
import PhotoWall201907 from '@/components/modules/photoWall/PhotoWall201907.vue'
import PhotoWall201908 from '@/components/modules/photoWall/PhotoWall201908.vue'
import PhotoWall201909 from '@/components/modules/photoWall/PhotoWall201909.vue'
import PhotoWall201910 from '@/components/modules/photoWall/PhotoWall201910.vue'
import PhotoWall10Sen from '@/components/modules/photoWall/PhotoWall10Sen.vue'
import PhotoWall100Kei from '@/components/modules/photoWall/PhotoWall100Kei.vue'
import PhotoWallMyPrecious from '@/components/modules/photoWall/PhotoWallMyPrecious.vue'
import PhotoWallSpacer from '@/components/modules/photoWall/PhotoWallSpacer.vue'
import UpButton from '@/components/modules/UpButton.vue'
import QuestionnaireButton from '@/components/modules/QuestionnaireButton.vue'
import YoutubeUtil from '@/util/YoutubeUtil'

export default {
  mixins: [enumMixin, constMixin], // Enum値, const値の読み込み
  components: {
    Header,
    Footer,
    ImageViewer,
    PortfolioViewer,
    BreadcrumbList,
    Comment,
    MessageDialog,
    PhotoWall201901,
    PhotoWall201902,
    PhotoWall201903,
    PhotoWall201904,
    PhotoWall201905,
    PhotoWall201906,
    PhotoWall201907,
    PhotoWall201908,
    PhotoWall201909,
    PhotoWall201910,
    PhotoWall10Sen,
    PhotoWall100Kei,
    PhotoWallMyPrecious,
    PhotoWallSpacer,
    UpButton,
    QuestionnaireButton
  },
  data () {
    return {
      swiper: null,
      isTest: false,
      isImageViewerOpen: false,
      commentaryType: '',
      isPortfolioViewerOpen: false,
      currentIndex: 0,
      currentWinner: { id: null },
      currentWinningWork: null,
      slides: [],
      virtualData: {
        slides: []
      },
      isWinnerIntroductionClose: {},
      isMessageOpen: false,
      messageTitle: '',
      messageText: '',
      currentScrollPosition: 0,
      isCursorUpOn: false,
      is10sen: false
    }
  },
  methods: {
    isDemo () {
      return process.env.VUE_APP_DEMO_HOST ? (location.host.indexOf(process.env.VUE_APP_DEMO_HOST) >= 0) : false
    },
    setTitleAndDescription (to) {
      const winner = this.winnersById(to.params.id)
      if (!winner) return

      // titleの設定
      let pageTitle = ''
      if (to.params.winningWorkId) {
        // 作品画像詳細の場合
        const winningWork = this.winningWorkById(to.params.winningWorkId)
        if (!winningWork) return
        pageTitle = `${this.awardTypeNames[winner.awardType]} ${winner.name}「${winningWork.title}」`
      } else if (to.params.portfolioId) {
        // ポートフォリオの場合
        pageTitle = `${winner.name}`
      } else {
        // 出展者の場合
        pageTitle = `${this.awardTypeNames[winner.awardType]} ${winner.name}`
      }
      document.title = pageTitle + (to.meta.title ? to.meta.title : '')
      // descriptionの設定
      const pageDescription = ''
      document.querySelector("meta[name='description']").setAttribute('content', (to.meta.desc ? to.meta.desc : '') + pageDescription)
    },
    // イメージビュワー表示
    openImageViewer (winningWork, commentaryType = null) {
      // モーダルダイアログを表示する際にはメインページ（背景ページ）のスクロールを固定する
      this.bodyFixedOn()

      this.currentWinner = this.winnersById(winningWork.winnerId)
      this.currentWinningWork = winningWork
      this.commentaryType = commentaryType
      this.isImageViewerOpen = true

      // 個別画像ページへURL書き換え
      const awardCode = this.awardTypeCode[this.currentWinner.awardType]
      const path = `/artworks/${awardCode}/${this.currentWinner.id}/images/${winningWork.id}`
      if (path !== this.$route.path) {
        this.$router.push(path)
      }
    },
    // メインページスクロール固定処理設定
    bodyFixedOn () {
      const ua = window.navigator.userAgent.toLowerCase()
      const isiOS = ua.indexOf('iphone') > -1 || ua.indexOf('ipad') > -1 || (ua.indexOf('macintosh') > -1 && 'ontouchend' in document)
      const body = document.body
      if (isiOS) {
        this.currentScrollPosition = window.pageYOffset
        body.style.position = 'fixed'
        body.style.top = `-${this.currentScrollPosition}px`
      } else {
        body.style.overflow = 'hidden'
      }
    },
    // メインページスクロール固定処理解除
    bodyFixedOff () {
      const ua = window.navigator.userAgent.toLowerCase()
      const isiOS = ua.indexOf('iphone') > -1 || ua.indexOf('ipad') > -1 || (ua.indexOf('macintosh') > -1 && 'ontouchend' in document)
      const body = document.body
      if (isiOS) {
        body.style.removeProperty('position')
        body.style.removeProperty('top')
        window.scrollTo(0, this.currentScrollPosition)
      } else {
        body.style.removeProperty('overflow')
      }
    },
    // ポートフォリオビュワー表示
    openPortfolioViewer (winner) {
      if (!winner.portfolios || winner.portfolios.length <= 0) {
        return // ポートフォリオが存在しない場合、処理終了
      }

      // モーダルダイアログを表示する際にはメインページ（背景ページ）のスクロールを固定する
      this.bodyFixedOn()

      this.currentWinner = winner
      this.isPortfolioViewerOpen = true

      // ポートフォリオページへURL書き換え
      const awardCode = this.awardTypeCode[this.currentWinner.awardType]
      const path = `/artworks/${awardCode}/${this.currentWinner.id}/portfolios/${winner.portfolios[0].id}`
      if (path !== this.$route.path) {
        this.$router.push(path)
      }
    },
    // スワイプ移動イベント
    slideChange (event) {
      const preIndex = this.currentIndex
      this.currentIndex = event.activeIndex
      this.currentWinner = this.winners[event.activeIndex]
      // 空白ページ判定
      // 空白ページだった場合、カテゴリの最初であれば、最後に、最後であれば、最初にジャンプする
      if (this.currentWinner.awardType === this.spacerAwardTypeId) {
        const index = this.getJumpIndex(preIndex)
        const path = this.createArtworksWinnerUrl(index)
        this.$router.push(path) // 最初もしくは最後にジャンプ
      } else {
        // 通常ページの場合の処理
        // パス生成
        const path = this.createArtworksWinnerUrl(event.activeIndex)
        // 移動先のパスが現在と違う場合書き換え
        // ただし、個別画像画面では無い（winningWorkIdパラメータで詳細画面が指定されていない）
        // かつ、ポートフォリオ画面では無い（portfolioIdパラメータでポートフォリオが指定されていない）
        // の条件を満たしている必要がある
        if (path !== this.$route.path && (!this.$route.params.winningWorkId && !this.$route.params.portfolioId)) {
          this.$router.push(path)
        }
      }

      // コメントがあればloadする
      if (this.$refs['comment' + this.currentWinner.id] && this.$refs['comment' + this.currentWinner.id][0]) {
        this.$refs['comment' + this.currentWinner.id][0].load()
      }
    },
    // 指定されたindexから飛び先のindexを取得
    getJumpIndex (index) {
      const sourceWinner = this.winners[index]
      let minIdIndex = null
      let maxIdIndex = null
      for (let i = 0; i < this.winners.length; i++) {
        const winner = this.winners[i]
        // 対象受賞カテゴリのindexの最小と最大を求める
        // 10選は一まとまりとするため先頭8文字のみ使用して比較している
        const sourceAwardTypeCode = this.awardTypeCode[sourceWinner.awardType].substring(0, 8)
        const code = this.awardTypeCode[winner.awardType].substring(0, 8)
        if (code === sourceAwardTypeCode) {
          if (minIdIndex === null) {
            minIdIndex = i
          }
          maxIdIndex = i
        }
      }
      if (minIdIndex >= index) {
        return maxIdIndex
      } else {
        return minIdIndex
      }
    },
    // index番号からURLを生成
    createArtworksWinnerUrl (index) {
      const awardCode = this.awardTypeCode[this.winners[index].awardType]
      const path = `/artworks/${awardCode}/${this.winners[index].id}`
      return path
    },
    // URLから特定のslideを表示するメソッド
    moveSlideByUrl () {
      // スライド移動
      if (this.winnersIndexById(this.$route.params.id) !== this.swiper.activeIndex) {
        this.swiper.slideTo(this.winnersIndexById(this.$route.params.id), 500, false)
        this.currentIndex = this.winnersIndexById(this.$route.params.id)
        this.currentWinner = this.winners[this.currentIndex]

        if (this.currentWinner && this.$refs['comment' + this.currentWinner.id] && this.$refs['comment' + this.currentWinner.id][0]) {
          this.$refs['comment' + this.currentWinner.id][0].load()
        }
      }
    },
    // 右へswipe
    moveNext () {
      if (this.currentIndex >= this.winners.length) {
        return
      }
      this.swiper.slideTo(this.currentIndex + 1, 500, false)
    },
    // 左へswipe
    movePrev () {
      if (this.currentIndex <= 0) {
        return
      }
      this.swiper.slideTo(this.currentIndex - 1, 500, false)
    },
    changeCommentaryMode (value) {
      const el = document.getElementById('openClose-' + this.currentWinner.id)
      if (value) {
        this.currentWinner.minusMargin = el.clientHeight
      } else {
        this.currentWinner.minusMargin = 0
      }
      this.$set(this.isWinnerIntroductionClose, this.currentWinner.id, value)
    },
    get10SenYear (id) {
      if (!id) return ''
      return String(id).substring(0, 4)
    },
    sanitizeAndAutoLink (str) {
      return AutoLinkUtil.convert(sanitizeHtml(str, { allowedTags: [], allowedAttributes: {} }))
    },
    isCommentExists (winner) {
      return (
        winner && winner.winnerIntroduction &&
        winner.winnerIntroduction.comment
      )
    },
    isMovieExists (winner) {
      return (
        winner && winner.winnerIntroduction &&
        winner.winnerIntroduction.youtubeUrl
      )
    },
    isVoiceExists (winner) {
      return (
        winner && winner.winnerIntroduction &&
        winner.winnerIntroduction.voiceUrl
      )
    },
    convertYoutubeUrl (url) {
      return YoutubeUtil.getEmbedUrl(url)
    },
    getWinningWorkByPath (path) {
      const pathList = path.split('/')
      if (pathList && pathList.length >= 5) {
        return this.winningWorkById(pathList[5])
      }
      return null
    },
    isProfileExists (winner) {
      return (
        (winner && winner.profileImageUrl) ||
        (winner && winner.profileStatement) ||
        (winner && winner.portfolios && winner.portfolios[0] && winner.portfolios[0].portfolioWorks)
      )
    }
  },
  computed: {
    ...mapGetters([
      'winners',
      'winnersById',
      'winnersIndexById',
      'winnersByAwardType',
      'winningWorkById'
    ]),
    slideStyles () {
      return `left: ${this.virtualData.offset}px`
    }
  },
  created () {
  },
  mounted () {
    // swiper初期設定
    const self = this
    this.swiper = new Swiper('.swiper-container', {
      shortSwipes: true, // スワイプの反応状態 true の場合、ちょっとずらしただけでスワイプする
      noSwiping: true,
      noSwipingSelector: '.notSwipe,input,textarea,.msgPstArea',
      virtual: {
        slides: this.winners,
        renderExternal (data) {
          self.virtualData = data
        }
      },
      on: {
        slideChange: this.slideChange
      }
    })
    // winnersのvuexへの読み込み状態を監視し、読み込まれたら表示を更新する
    this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'setWinners') {
        this.swiper.virtual.appendSlide(this.winners)

        // またURLの指定された位置を検知にswiperを適切なindex番号に遷移させる
        this.swiper.slideTo(this.winnersIndexById(this.$route.params.id), 0, false)

        // 現在位置情報を保持
        this.currentIndex = this.winnersIndexById(this.$route.params.id)
        this.currentWinner = this.winners[this.currentIndex]

        // 存在しないURLが指定されていた場合Not Foundに遷移
        // 読み込み完了までにタイムラグがあるため、setTimeoutで実行
        setTimeout(() => {
          // 出展者が存在しない場合
          if (!this.winnersById(this.$route.params.id)) {
            this.$router.push('/notFound')
          }
        }, 300)

        // 画像ビュワー表示判定
        // winningWorkIdが指定されているのにもかかわらず、画像個別ウインドウが表示されていなければ表示
        if (this.$route.params.winningWorkId && !this.isImageViewerOpen) {
          let winningWork = null
          for (const wWork of this.currentWinner.winningWorks) {
            if (String(wWork.id) === this.$route.params.winningWorkId) {
              winningWork = wWork
              break
            }
          }
          // 作品が存在しない場合
          if (this.$route.params.winningWorkId && !this.winningWorkById(this.$route.params.winningWorkId)) {
            this.bodyFixedOff()
            this.$router.push('/notFound')
            return
          }

          this.openImageViewer(winningWork)
        }

        // ポートフォリオ表示判定
        // portfolioIdが指定されているのにもかかわらず、ポートフォリオウインドウが表示されていなければ表示
        if (this.$route.params.portfolioId && !this.isPortfolioViewerOpen) {
          this.openPortfolioViewer(this.currentWinner)
        }

        // titleとdescriptionの設定
        this.setTitleAndDescription(this.$route)

        // 10選判定
        this.is10sen = (this.$route.path.indexOf('/artworks/Tcc10Sen') >= 0)
      }
    })
    this.moveSlideByUrl()
    // titleとdescriptionの設定
    this.setTitleAndDescription(this.$route)
  },
  watch: {
    // モーダルウインドウが閉じられたらメインページのスクロールができるようにする
    isImageViewerOpen: function (val, oldVal) {
      if (!val) {
        this.bodyFixedOff()
      }
    },
    // モーダルウインドウが閉じられたらメインページのスクロールができるようにする
    isPortfolioViewerOpen: function (val, oldVal) {
      if (!val) {
        this.bodyFixedOff()
      }
    },
    $route: function (to, from) {
      this.setTitleAndDescription(to)
    },
    '$route.path': function (val, oldVal) {
      this.moveSlideByUrl()

      // 10選判定
      this.is10sen = (this.$route.path.indexOf('/artworks/Tcc10Sen') >= 0)

      // 旧URLに /images/ が無く、新URLに /images/ があった場合（戻るボタンで戻ってきた場合）かつ未だウインドウがopenされてない場合、ウインドウをopen
      const index = val.indexOf('/images/')
      const oldIndex = oldVal.indexOf('/images/')
      if (oldIndex < 0 && index >= 0 && !this.isImageViewerOpen) {
        const winningWork = this.getWinningWorkByPath(this.$route.path)
        if (winningWork) {
          this.openImageViewer(winningWork) // 表示
        }
      }
    }
  }
}
</script>

<style scoped>
@import '~swiper/swiper-bundle.css';

.imgArtwork {
  width: 250px;
  height: 250px;
  object-fit: contain;
}

.cursorRight {
  width: 42px;
  height: 44px;
  position: fixed;
  right: 8px;
  top:calc(50% - 88px/2);
  z-index: 2000;
}

.cursorLeft {
  width: 42px;
  height: 44px;
  position: fixed;
  left: 8px;
  top:calc(50% - 88px/2);
  z-index: 2000;
}

.cursorDisable {
  opacity: 0.5;
  cursor: default;
}

.openCloseAnimation {
  margin-top: 0px;
  transition: all 1s;
  opacity: 1;
  margin-top: -5px;
}

.hideCommentary {
  /* margin-top: -600px; */
  opacity: 0;
}

@media screen and ( max-width:640px) {
  .cursorRight {
    width: 28px;
    height: 29px;
    right: 4px;
  }
  .cursorLeft {
    width: 28px;
    height: 29px;
    left: 4px;
  }
}

.background10sen {
  background-image: url('/img/artworkBg5.png');
  background-repeat: no-repeat;
  background-position: center bottom;
  background-size: contain;

}
</style>
